import { styled } from "@mui/material/styles";
import { Button } from "@volt_developers/components/components/Button";
import { ButtonDropdownDeprecated } from "@volt_developers/components/components/ButtonDeprecated";
import { VerticalDotsIcon } from "@volt_developers/components/components/Icons";

import type { PropsWithChildren } from "react";

export interface DropdownNavigationProps extends PropsWithChildren {
  buttonTestId?: string;
}

export function DropdownNavigation({
  buttonTestId,
  children,
}: DropdownNavigationProps) {
  return (
    <Wrapper>
      <ButtonDropdownDeprecated>
        <Button.Wrapper
          color="secondary"
          data-testid={buttonTestId}
          variant="outlined"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: BUTTON_HEIGHT,
          }}
        >
          <Button.Text>
            <VerticalDotsIcon
              sx={{
                height: ICON_HEIGHT,
                position: "relative",
                top: ICON_TOP_POSITION_CLEARING_PADDING,
              }}
            />
          </Button.Text>
        </Button.Wrapper>
        {children}
      </ButtonDropdownDeprecated>
    </Wrapper>
  );
}

const ICON_HEIGHT = 18;

const ICON_TOP_POSITION_CLEARING_PADDING = 2;

const BUTTON_HEIGHT = 36;

const Wrapper = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  position: "relative",
});
